import { ArticleContext } from 'providers/Article'
import { ArticleScrollContext } from 'providers/ArticleScroll'
import { FilterContext } from 'providers/Filter'
import React, { useContext, useEffect } from 'react'
import { Typography } from '@xprog/prensa'

const ARTICLE_VIEWING = 'article:viewing'

const ContinuousReadingWidgetWrapper = (props): any => {
  const { itemsData, renderItem, slots } = props
  const articleState = useContext(ArticleContext)
  const articleScrollState = useContext(ArticleScrollContext)
  const filterContext = useContext(FilterContext)

  let items: any = []

  if (filterContext.sideBoxFilter === '1') {
    items = articleState.articles.map((i: any, key: number) => {
      const selectedScroll = articleScrollState.state[i.id]

      const ScrollableLink = (props) => {
        function handleClick(e) {
          e.preventDefault()
          window.scrollTo(0, window.scrollY + 1 + (selectedScroll.top * -1))
        }
        return (
          <a
            href={props.href}
            onClick={handleClick}
            title={props.title}
          >
            <Typography
              as='p'
              css={{
                color: 'black',
                fontSize: '$widget5',
                fontWeight: '$widget5',
                lineHeight: '$widget5'
              }}>
              {props.title}
            </Typography>
          </a>
        )
      }

      if (selectedScroll?.viewing) {
        if (window) {
          window.dispatchEvent(new CustomEvent(ARTICLE_VIEWING, {
            detail: {
              article: i,
              viewing: selectedScroll.viewing,
              viewed: selectedScroll.viewed,
              progress: selectedScroll.progress,
            }
          }))
        }
      }

      return renderItem({
        item: {
          ...i,
          customProps: {
            customLink: ScrollableLink,
            'data-selected': selectedScroll?.viewing,
            'data-viewed': selectedScroll?.viewed,
            style: { backgroundImage: `linear-gradient(90deg, hsl(0deg 0% 91%) ${selectedScroll?.progress}%, hsl(0deg 0% 100%) ${selectedScroll?.progress}%)` }
          }
        },
        position: key
      })
    })
  } else if (filterContext.sideBoxFilter === '2') {
    const mostReadItems: any = []
    slots.forEach((i) => {
      const item = itemsData.find((d) => d.id === i.replace('contentid/', 'policy:'))
      item && mostReadItems.push(item)
    })
    items = mostReadItems.map((i, key) => renderItem({ item: i, position: key }))
  }
  return items
}

export default ContinuousReadingWidgetWrapper
